import { Helmet } from 'react-helmet-async';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'TravelAgency',
  name: 'Noche y Día Turismo',
  url: 'https://nocheydiaturismo.com',
  logo: 'https://nocheydiaturismo.com/static/media/LOGO.54bc0c4e32db6b00b8af4de0bcf68d5f.svg',
  image: 'https://nocheydiaturismo.com/static/media/LOGO.54bc0c4e32db6b00b8af4de0bcf68d5f.svg',
  description: 'Agencia de turismo líder en salidas grupales desde 1993. Paquetes nacionales e internacionales.',
  telephone: '+541144328675',
  priceRange: '$150.000 - $5.000.000 ARS',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Yerbal 1136',
    addressLocality: 'Buenos Aires',
    addressRegion: 'Ciudad Autónoma de Buenos Aires',
    postalCode: '1406',
    addressCountry: 'AR',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    telephone: '+541144328675',
    url: 'https://nocheydiaturismo.com/contacto',
    areaServed: 'AR',
    availableLanguage: 'Spanish',
  },
};

function OrganizationSchema() {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}

export default OrganizationSchema;
